// Batch B · Round B1 · M1 — LTR-isolated amount so negative numbers
// always show "-205,459" instead of "205,459-" in AR mode.
// STEP 3 · rule 2 · B-2e (owner 26-Oct-2026): THE amount formatter of the screens — every amount on a page / component goes
// through `Amount` or `fmtNumber` (Western digits in both languages, thousands separators, fixed decimals, never "-0.00").
// A browser-locale `toLocaleString(undefined, …)` would show Eastern Arabic digits on an Arabic browser; the jest guard
// src/__tests__/S3R2AmountFormat.test.js fails when one comes back. The backend's PDF twin is backend/amount_fmt.py.
import React from "react";

const _NF = {};
function nf(decimals) {
  const d = Math.max(0, Math.min(20, Number.isInteger(decimals) ? decimals : 2));
  if (!_NF[d]) {
    // Batch 6 · E (AT-62): a fixed number of decimals, never "3,421,324.5"
    _NF[d] = new Intl.NumberFormat("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  return [_NF[d], d];
}

export function fmtNumber(n, { decimals = 2 } = {}) {
  if (n == null || Number.isNaN(Number(n))) return "";
  const [f, d] = nf(decimals);
  let v = Number(n);
  if (Math.abs(v) < 0.5 * 10 ** -d) v = 0;   // Batch 8.1 · F-37: rounds to zero → "0.00", never "-0.00"
  return f.format(v);
}

// STEP 3 combined · B6b (owner 27-Oct-2026): THE count formatter (rows, lines, vouchers, items, objects, tokens …) — the same
// fixed en-US Western-digit mechanism as fmtNumber, whole numbers, thousands separators ("12,345"). A no-argument
// `.toLocaleString()` follows the BROWSER locale (Eastern Arabic digits on an Arabic browser); the jest guard
// src/__tests__/S3R2AmountFormat.test.js fails when one comes back anywhere in src/. Missing / not a number → "" (as fmtNumber).
const _NF_COUNT = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
export function fmtCount(n) {
  if (n == null || n === "" || !Number.isFinite(Number(n))) return "";
  const v = Number(n);
  return _NF_COUNT.format(Math.abs(v) < 0.5 ? 0 : v);   // never "-0"
}

export function Amount({ value, decimals = 2, suffix = "",
                          className = "font-mono", ...rest }) {
  const s = fmtNumber(value, { decimals });
  if (!s) return <span className={className} {...rest} />;
  return (
    <bdi dir="ltr" className={className} {...rest}>
      {s}{suffix}
    </bdi>
  );
}

export default Amount;
